import React from 'react'
import { useNavigate } from 'react-router-dom'
import Icon from '../../components/Icon/Icon'
import './Legal.scss'

function CookiePolicy() {
    const navigate = useNavigate()

    const handleGoBack = () => {
        if (window.history.length > 1) {
            navigate(-1)
        } else {
            navigate('/')
        }
    }

    return (
        <div className="legal-wrapper">
            <div className="legal-nav-container">
                <div className="legal-nav-inner">
                    <button 
                        className="legal-nav-back" 
                        onClick={handleGoBack}
                        aria-label="Go back"
                        tabIndex={0}
                        onKeyDown={(e) => e.key === 'Enter' && handleGoBack()}
                    >
                        <Icon alias="chevron-left" stroke="#0A0F1E" color="#0A0F1E" width={24} />
                    </button>
                    <h1 className="legal-nav-title">Politique cookies</h1>
                </div>
            </div>

            <div className="legal-container">
                <section className="legal-section">
                    <p>
                        HYK MEDIA, société par actions simplifiée, dont le siège social est situé 38, rue des Saints-Pères, 75007 à Paris et immatriculée au Registre du Commerce et des Sociétés de Paris sous le numéro 928 546 142, représentée par son Président, Monsieur Abdallah Slaiman (ci-après « HYK ») ou des opérateurs tiers sont susceptibles de déposer des cookies sur le terminal (ordinateur, smartphone, tablette) de l'utilisateur (ci-après l'« Utilisateur ») lors de sa connexion au site Internet https://hyk.media (ci-après le « Site »).
                    </p>
                </section>

                <section className="legal-section">
                    <h2>1. Les cookies, c'est quoi ?</h2>
                    <p>
                        Un cookie est un fichier stocké par un serveur dans un terminal (ordinateur, téléphone, etc.) et associé à un domaine web (c'est à dire dans la majorité des cas à l'ensemble des pages d'un même site web). Les cookies sont ainsi placés sur l'ordinateur de l'Utilisateur par les sites Internet qu'il visite. Les cookies sont ensuite renvoyés au site Internet d'origine à chaque visite ultérieure, ou à un autre site Internet qui reconnaît ce cookie.
                    </p>
                    <p>
                        Ils sont utilisés pour faire fonctionner les sites Internet, ou les faire fonctionner plus efficacement, ainsi que pour fournir des informations aux propriétaires du site Internet. Les cookies ont ainsi de multiples usages : ils peuvent servir à mémoriser l'identifiant client de l'utilisateur auprès d'un site ou encore la langue d'affichage de la page web, un identifiant permettant de tracer la navigation à des fins statistiques ou publicitaires, etc.
                    </p>
                    <p>
                        Certains de ces usages sont strictement nécessaires aux fonctionnalités expressément demandées par l'utilisateur ou bien à l'établissement de la communication et donc exemptés de consentement. D'autres, qui ne correspondent pas à ces critères, nécessitent un consentement de l'utilisateur avant lecture ou écriture.
                    </p>
                    <p>
                        Les cookies « internes » sont déposés par le site consulté, plus précisément sur le domaine du site. Ils peuvent être utilisés pour le bon fonctionnement du site ou pour collecter des données personnelles afin de suivre le comportement de l'internaute et servir à des finalités publicitaires. Les cookies « tiers » sont les cookies déposés sur des domaines différents de celui du site principal, généralement gérés par des tiers qui ont été interrogés par le site visité et non par l'internaute lui-même : ces cookies peuvent aussi être nécessaires au bon fonctionnement du site mais ils servent également à collecter des informations sur l'internaute concerné.
                    </p>
                    <p>
                        Nous utilisons le terme « cookies » tout au long de cette politique de cookies pour couvrir également toutes les technologies de suivi similaires ou les fichiers journaux.
                    </p>
                    <p>
                        Afin d'assurer le fonctionnement de notre Site, nous utilisons des cookies sur différentes pages. Certains des cookies que nous utilisons sont supprimés après la fin de la session du navigateur, c'est-à-dire après la fermeture du navigateur de l'Utilisateur (cookies dits de session). D'autres cookies restent sur le terminal de l'Utilisateur et permettent au navigateur de l'Utilisateur d'être reconnu lors de sa prochaine visite (cookies dits persistants). Si des cookies sont activés, ils collectent et traitent certaines informations utilisateur telles que les données de du navigateur de l'Utilisateur, de localisation ainsi que l'adresse IP. Les cookies persistants sont automatiquement supprimés après une période spécifiée, qui peut varier en fonction du cookie.
                    </p>
                </section>

                <section className="legal-section">
                    <h2>2. Quels types de cookies sont utilisés sur le Site et pourquoi ?</h2>

                    <h3>Cookies essentiels et fonctionnels</h3>
                    <p>
                        Les cookies essentiels sont indispensables au bon fonctionnement et à la sécurité du Site. Ils permettent à l'Utilisateur d'accéder au Site.
                    </p>
                    <p>
                        Les cookies fonctionnels permettent au Site de fonctionner de manière optimale et sont utilisés afin de proposer à l'Utilisateur un meilleur service.
                    </p>

                    <div className="legal-table-container">
                        <table className="legal-table">
                            <thead>
                                <tr>
                                    <th>Nom du cookie</th>
                                    <th>Données collectées</th>
                                    <th>Finalité</th>
                                    <th>Durée de vie</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>_cmp (CMP – gestion des consentements)</td>
                                    <td>Consentement utilisateur, préférences en matière de cookies</td>
                                    <td>Gérer les préférences de consentement de l'utilisateur et assurer la conformité RGPD</td>
                                    <td>6 mois</td>
                                </tr>
                                <tr>
                                    <td>firebase_auth (Firebase Auth)</td>
                                    <td>ID utilisateur, informations de session, token d'accès</td>
                                    <td>Permettre l'authentification sécurisée des utilisateurs sur l'app HYK</td>
                                    <td>Session</td>
                                </tr>
                                <tr>
                                    <td>session_HYK</td>
                                    <td>Identifiant de session, langue, préférences d'affichage</td>
                                    <td>Assurer la continuité de session et le bon fonctionnement de la web-app</td>
                                    <td>Session</td>
                                </tr>
                                <tr>
                                    <td>cookie_consent</td>
                                    <td>Choix utilisateur (acceptation/refus)</td>
                                    <td>Sauvegarder les choix de cookies</td>
                                    <td>6 mois</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <h3>Cookies analytiques et de performance</h3>
                    <p>
                        Ces cookies permettent de fournir uniquement des données statistiques anonymes de fréquentation (le nombre de pages vues, le nombre de visites, leur fréquence de retour, etc.) et de mesure de l'audience du Site (mesure des performances, détection de problèmes de navigation, optimisation des performances techniques ou de son ergonomie, estimation de la puissance des serveurs nécessaires, analyse des contenus consultés).
                    </p>

                    <div className="legal-table-container">
                        <table className="legal-table">
                            <thead>
                                <tr>
                                    <th>Nom du cookie</th>
                                    <th>Données collectées</th>
                                    <th>Finalité</th>
                                    <th>Durée de vie</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>_ga, _gid, _gat (Google Analytics 4)</td>
                                    <td>Données anonymisées de navigation, pages consultées, durée des sessions</td>
                                    <td>Mesurer l'audience, la performance et l'utilisation de la web-app</td>
                                    <td>13 mois</td>
                                </tr>
                                <tr>
                                    <td>_clck, _clsk (Microsoft Clarity)</td>
                                    <td>Comportements de navigation, mouvements de souris, clics, pages vues</td>
                                    <td>Analyser le comportement utilisateur pour améliorer l'ergonomie</td>
                                    <td>12 mois</td>
                                </tr>
                                <tr>
                                    <td>mp_XXXX_mixpanel (Mixpanel)</td>
                                    <td>ID anonyme utilisateur, actions effectuées sur l'app, durée, parcours</td>
                                    <td>Suivre les interactions clés et optimiser le parcours utilisateur</td>
                                    <td>12 mois</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <h3>Cookies de navigation</h3>
                    <p>
                        Ces cookies permettent de recueillir des informations relatives à la navigation de l'Utilisateur sur le Site (pages visitées, contenus visualisés, durée de la navigation, etc.) afin d'obtenir des statistiques individualisées sur les centres d'intérêt des Utilisateurs et notamment à propos des partenaires commerciaux de HYK, sur le Site et améliorer l'expérience utilisateur.
                    </p>

                    <div className="legal-table-container">
                        <table className="legal-table">
                            <thead>
                                <tr>
                                    <th>Nom du cookie</th>
                                    <th>Données collectées</th>
                                    <th>Finalité</th>
                                    <th>Durée de vie</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>firebase_analytics</td>
                                    <td>Données de navigation anonymisées, événements utilisateurs</td>
                                    <td>Personnalisation des contenus selon l'usage et les centres d'intérêt</td>
                                    <td>13 mois</td>
                                </tr>
                                <tr>
                                    <td>HYK_user_prefs</td>
                                    <td>Thèmes, langue, préférences utilisateur</td>
                                    <td>Adapter l'expérience utilisateur à ses choix</td>
                                    <td>12 mois</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <h3>Cookies tiers</h3>
                    <p>
                        Certaines fonctionnalités du Site reposent sur des services fournis par des sites Internet tiers, notamment la possibilité de partager des contenus avec des réseaux sociaux. Si l'Utilisateur y consent, ces derniers collecteront ses données de navigation et utiliseront les données collectées via leurs cookies à des fins spécifiques, conformément à leur propre politique de confidentialité.
                    </p>
                    <p>
                        HYK ne contrôle pas ces cookies ni les données qu'ils permettent de collecter par les réseaux sociaux agissant pour leur propre compte. Pour plus d'informations sur ces applications et les finalités pour lesquelles elles sont utilisées, les Utilisateurs sont invités à consulter les politiques de confidentialité spécifiques de chacun de ces sites de réseaux sociaux : Instagram, LinkedIn, Facebook, X, TikTok.
                    </p>

                    <div className="legal-table-container">
                        <table className="legal-table">
                            <thead>
                                <tr>
                                    <th>Nom du cookie</th>
                                    <th>Données collectées</th>
                                    <th>Finalité</th>
                                    <th>Durée de vie</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>__sg_view, __sg_email (SendGrid)</td>
                                    <td>Données d'ouverture, clics dans les emails</td>
                                    <td>Mesurer la performance des emails transactionnels et marketing</td>
                                    <td>6 mois</td>
                                </tr>
                                <tr>
                                    <td>_fbp, _tt_session, _li_id (Facebook / TikTok / LinkedIn Pixel)</td>
                                    <td>Données de navigation, provenance, conversions</td>
                                    <td>Suivre la performance des campagnes publicitaires</td>
                                    <td>3 à 6 mois</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <p>
                        Les cookies essentiels, installés exclusivement pour faciliter la communication électronique ou nécessaires à la fourniture du service sur Internet, sont déposés automatiquement sur le terminal de l'Utilisateur lorsqu'il navigue sur le Site. L'Utilisateur ne peut pas les désactiver.
                    </p>
                    <p>
                        Les cookies fonctionnels, de mesure d'audience ou de navigation sont déposés sur le terminal de l'Utilisateur s'il y a consenti en cliquant sur « accepter ». Le traitement des données collectées à partir de ces cookies est donc basé sur le consentement de l'Utilisateur, qu'il peut retirer à tout moment. Les cookies analytiques et de performance ne sont activés qu'après consentement explicite de l'utilisateur via la CMP. Les données collectées sont anonymisées dans la mesure du possible, conformément au RGPD et aux recommandations de la CNIL. HYK et la web-app HYK ne partagent aucune donnée personnelle sans consentement explicite.
                    </p>
                    <p>
                        Les cookies ont une durée de vie maximale de treize (13) mois. Certains cookies nécessiteront le consentement de l'Utilisateur pour être conservés plus de six (6) mois.
                    </p>
                </section>

                <section className="legal-section">
                    <h2>3. Gérer les préférences cookies</h2>
                    <p>
                        Lorsque l'Utilisateur visite le Site, il est informé du dépôt de cookies sur son terminal et il peut décider d'accepter, de refuser ou de choisir les cookies qui nécessitent son consentement.
                    </p>
                    <p>
                        Un outil de gestion du consentement de l'Utilisateur est accessible sur le bandeau de paramétrage des cookies. Il permet à l'Utilisateur de définir à tout moment son choix en matière de cookies.
                    </p>
                    <p>
                        L'Utilisateur peut également modifier ses préférences en matière de cookies en accédant aux paramètres de son navigateur.
                    </p>
                </section>

                <section className="legal-section">
                    <h2>4. Mise à jour de la politique de cookies</h2>
                    <p>
                        HYK se réserve le droit de modifier et/ou de corriger la présente politique de cookies à tout moment. HYK publiera des mises à jour sur son Site.
                    </p>
                </section>

                <section className="legal-section legal-contact">
                    <h2>Contact</h2>
                    <p>
                        Pour toute question relative à cette politique de cookies, vous pouvez contacter HYK à l'adresse suivante : <a href="mailto:connect@hyk.media">connect@hyk.media</a>
                    </p>
                </section>
            </div>
        </div>
    )
}

export default CookiePolicy
